import { HTTP } from "@/utils/http-common";

export default {
  get_profile() {
    return HTTP.get("/account/settings/user/");
  },
  get_api_keys() {
    return HTTP.get("/account/settings/user/api-keys/");
  },
  generate_api_keys() {
    return HTTP.get("/account/settings/user/api-keys/generate/");
  },
  get_audit_list(query) {
    return HTTP.get("/audit/list/" + query);
  },
  get_team_members() {
    return HTTP.get("account/settings/team/");
  },
  sendInvite(invites, parent) {
    HTTP.post("/invitations/send-json-invite/", invites)
      .then(function(response) {
        if (response.data.invalid.length === 0) {
          parent.$store.commit("push", {
            msg: "invite(s) sent",
            color: "success"
          });
          parent.invites = [
            {
              email: "",
              privileges: {
                data_manager: false,
                api_manager: false,
                function_manager: false
              }
            }
          ];
        } else {
          var err = response.data;
          console.log(err);
          var item, email, index;
          for (item in err.invalid) {
            for (var prop in err.invalid[item]) {
              email = prop;
              break;
            }
            index = invites.findIndex(x => x.email == email);
            parent.errors.add("email" + index, err.invalid[item][email]);
          }
          parent.$store.commit("push", {
            msg: "some invites failed or are already pending",
            color: "warning"
          });
        }
      })
      .catch(function(error) {
        var err = error.response.data;
        if (err !== undefined) {
          var item, email, index;
          for (item in err.invalid) {
            for (var prop in err.invalid[item]) {
              email = prop;
              break;
            }
            index = invites.findIndex(x => x.email == email);
            parent.errors.add("email" + index, err.invalid[item][email]);
          }
          parent.$store.commit("push", {
            msg: "error when sending invites (check emails)",
            color: "error"
          });
        } else {
          parent.$store.commit("push", {
            msg: err,
            color: "error"
          });
        }
      });
  },
  changePassword(old, new1, new2, parent) {
    HTTP.post("/account/password/change/", {
      new_password1: new1,
      new_password2: new2,
      old_password: old
    })
      .then(function(response) {
        parent.$store.commit("push", {
          msg: response.data.detail,
          color: "success"
        });
      })
      .catch(function(error) {
        var err = error.response.data;
        for (var prop in err) {
          parent.errors.add(prop, err[prop]);
        }
        parent.$store.commit("push", {
          msg: err,
          color: "error"
        });
      });
  },
  changeName(firstName, lastName, username, parent) {
    HTTP.put("/account/settings/user/", {
      first_name: firstName,
      last_name: lastName,
      username: username
    })
      .then(function(response) {
        parent.$store.commit("push", {
          msg: "profile updated",
          color: "success"
        });
      })
      .catch(function(error) {
        var err = error.response.data;
        for (var prop in err) {
          parent.errors.add(prop, err[prop]);
        }
        parent.$store.commit("push", {
          msg: err.username,
          color: "error"
        });
      });
  },
  changeStatus(user, newStatus, parent) {
    return HTTP.get("/account/" + user.username + "/" + newStatus + "/");
  },
  modifyMember(user, parent) {
    var permissions = {
      data_manager: user.data_manager,
      api_manager: user.api_manager,
      function_manager: user.function_manager
    };
    HTTP.post("/permissions/" + user.username + "/manage/", permissions)
      .then(function(response) {
        parent.$store.commit("push", {
          msg: response.data.msg,
          color: "success"
        });
      })
      .catch(function(error) {
        var item;
        for (item in error.response.data) {
          parent.$store.commit("push", {
            msg: error.response.data[item],
            color: "error"
          });
          break;
        }
      });
  },
  deactivateAccount() {
    return HTTP.get("/account/deactivate/");
  },
  getCompanyInfo() {
    return HTTP.get("/account/settings/company/");
  },
  changeCompanyInfo(info, parent) {
    HTTP.put("/account/settings/company/", info)
      .then(function(response) {
        parent.$store.commit("push", {
          msg: "Configuration updated",
          color: "success"
        });
      })
      .catch(function(error) {
        parent.$store.commit("push", {
          msg: error.response,
          color: "error"
        });
      });
  },
  deleteCompany() {
    return HTTP.delete("/account/settings/company/");
  },
  companyReset(info, parent) {
    HTTP.put("/account/settings/company/reset/", info)
      .then(function(response) {
        parent.$store.commit("push", {
          msg: "Objects removed",
          color: "success"
        });
      })
      .catch(function(error) {
        parent.$store.commit("push", {
          msg: error.response.data.error,
          color: "error"
        });
      });
  },

  getListAdminSite() {
    return HTTP.get("/admin/sites/");
  }
};
